import { StatesModule } from '@uirouter/angular';
import { FiAdIntegrationComponent } from './ad-integration.component';
import { PageTitleService } from '../../utilities/fi-services/page-title.service';
import { ApplicationSettingsType } from '../../shared/types/application-settings-type';
import { AccessRightType } from '../../shared/types/access-right-type';
import { StateAccessCheckService } from '../../shared/fi-shared-services/state-access-check.service';
import { FiAbstractStateComponent } from '../../shared/fi-state-proxy/fi-abstract-state.component';

export const FiADIntegrationStates: StatesModule = {
    states: [
        {
            url: '/ADIntegration',
            name: 'ADIntegration',
            abstract: true,
            component: FiAbstractStateComponent,
            parent: 'Module',
        },
        {
            name: 'ADIntegration.GroupMapping',
            url: '/GroupMapping',
            component: FiAdIntegrationComponent,
            resolve: {
                pageTitle: [PageTitleService, FiADIntegrationStatesGroupMappingResolvePageTitle],
            },
        },
        {
            name: 'ADIntegration.Import',
            url: '/Import',
            component: FiAdIntegrationComponent,
            resolve: {
                pageTitle: [PageTitleService, FiADIntegrationStatesADImportResolvePageTitle],
            },
        },
    ],
};

export function FiADIntegrationStatesGroupMappingResolvePageTitle(pageTitleService: PageTitleService) {
    return pageTitleService.setTitle('Active Directory Integration - Group Mapping');
}

export function FiADIntegrationStatesADImportResolvePageTitle(pageTitleService: PageTitleService) {
    return pageTitleService.setTitle('Active Directory Integration - Group Mapping');
}

export function registerADStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules(
        ['ADIntegration', 'ADIntegration.GroupMapping', 'ADIntegration.ADImport'],
        {
            SettingType: [ApplicationSettingsType.ADIntegration],
            AccessType: AccessRightType.Admin,
        },
    );
}
